import config from '../nyConfig'
const ApiCoupon = {
    "创建批次": new config({ url: '/coupon/createBatch', showSuccessMessage: true, useToken: true }),
    "批次列表": new config({ url: '/coupon/listBatch', showSuccessMessage: false, useToken: true }),
    "券码列表": new config({ url: '/coupon/listCoupon', showSuccessMessage: false, useToken: true }),
    "导出券码列表": new config({ url: '/coupon/exportCoupon', showSuccessMessage: false, useToken: true }),
}

export default ApiCoupon